










































































































































































































































































































































import Vue from 'vue'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'

import { ApolloResponse } from '@/interfaces/apollo'
import { showErrors } from '@/utils/snack'
import { Ticket, TicketInput, ReducedTicket } from '@/modules/Ticket/interfaces/ticket'
import { User, ReducedUser } from '@/modules/User/interfaces/user'
import { ReducedLabel } from '@/modules/Label/interfaces/label'
import AppLightModal from '@/components/AppLightModal.vue'
import AppSearch from '@/components/AppSearch.vue'
import { getTicketsRelationCandidates } from '@/modules/Ticket/gql/ticket.gql'
import { dateToDisplay, todayToParse, dateTimeToParse } from '@/utils/dateTime'

interface Props {
  expectedTime?: string
  priority: string
  labels: ReducedLabel[]
  assignees: ReducedUser[]
  supervisors: ReducedUser[]
  relatedTickets: ReducedTicket[]

  [key: string]: any
}

interface ModalConf {
  type: string,
  show: boolean,
  x: number,
  y: number,
  bg: string,
}

@Component({
  components: {
    AppLightModal,
    AppSearch
  }
})
export default class TicketProps extends Vue {
  @Prop() readonly value!: TicketInput
  @Prop({ type: Boolean, default: false }) readonly isDetail!: boolean
  @Prop({ type: Boolean, default: false }) readonly isFounder!: boolean

  ticket: Props = {
    expectedTime: '',
    priority: '',
    labels: [],
    assignees: [],
    supervisors: [],
    relatedTickets: []
  }

  candidates: any = {
    labels: [],
    assignees: [],
    supervisors: [],
    relatedTickets: []
  }

  showExpectedTime = false
  showAssignees = false
  showSupervisor = false
  showRelated = false
  showLabel = false
  showPriority = false

  searchUser = ''
  searchRelated = ''

  modal: ModalConf = {
    type: '',
    show: false,
    x: 0,
    y: 0,
    bg: 'white'
  }

  allUsers: ReducedUser[] = []
  labels: ReducedLabel[] = []

  model: any = {
    expectedTime: '',
    priority: '',
    labels: [],
    assignees: [],
    supervisors: [],
    relatedTickets: []
  }

  nowDate = todayToParse()

  get filteredAssignees () {
    if (this.searchUser === '') return this.candidates.assignees
    return this.$R.filter((user: ReducedUser) => {
      return user.username.indexOf(this.searchUser) !== -1
    }, this.candidates.assignees)
  }

  get filteredSupervisors () {
    if (this.searchUser === '') return this.candidates.supervisors
    return this.$R.filter((user: ReducedUser) => {
      return user.username.indexOf(this.searchUser) !== -1
    }, this.candidates.supervisors)
  }

  get filteredTickets () {
    if (this.searchRelated === '') return this.candidates.relatedTickets
    return this.$R.filter((ticket: ReducedTicket) => {
      return ticket.name.indexOf(this.searchRelated) !== -1
    }, this.candidates.relatedTickets)
  }

  get expectedTime () {
    return dateTimeToParse(this.ticket.expectedTime ? this.ticket.expectedTime : this.nowDate)
  }

  dateToDisplay = dateToDisplay

  mounted () {
    this.model = this.value
    this.ticket.priority = this.model.priority
    this.ticket.expectedTime = dateTimeToParse(this.model.expectedTime)
    this.getAllCandidates()
  }

  @Watch('value')
  onValueChanged (val: any) {
    this.reset()
    this.model = this.value
    this.ticket.priority = this.model.priority
    this.ticket.expectedTime = dateTimeToParse(this.model.expectedTime)
    this.getAllCandidates()
  }

  @Watch('ticket.assignees')
  onAssigneesChanged (val: User[]) {
    this.value.assignees = val
  }
  @Watch('ticket.supervisors')
  onSupervisorsChanged (val: User[]) {
    this.value.supervisors = val
  }
  @Watch('ticket.labels')
  onLabelsChanged (val: ReducedLabel[]) {
    this.value.labels = val
  }
  @Watch('ticket.relatedTickets')
  onRelatedChanged (val: Ticket[]) {
    this.value.relatedTickets = val
  }
  @Watch('ticket.expectedTime')
  onExpectedTimeChanged (val: string) {
    this.value.expectedTime = val
  }
  @Watch('ticket.priority')
  onPriorityChanged (val: string) {
    this.value.priority = val
  }

  @Emit('input')
  valueChanged () {
    return this.model
  }

  showModal (e: MouseEvent, type: string, bg?: string) {
    this.modal = {
      type,
      show: true,
      x: window.innerWidth - e.clientX - 20,
      y: e.clientY + 30,
      bg: bg || 'white'
    }
  }

  @Emit('change')
  hideModal () {
    const { type } = this.modal
    this.modal = {
      type: '',
      show: false,
      x: 0,
      y: 0,
      bg: 'white'
    }
    return type
  }

  valueChangedHandler (val: string) {
    this.ticket.expectedTime = val
    this.hideModal()
  }

  async getAllCandidates () {
    const { relatedTickets, supervisors, assignees, labels } = this.model
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getTicketsRelationCandidates
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      const tickets = result.data.getTicketsRelationCandidates.tickets
      const users = result.data.getTicketsRelationCandidates.users
      const labelsAll = result.data.getTicketsRelationCandidates.labels
      users.map((user: any) => {
        if (this.$R.find(this.$R.propEq('id', user.id.toString()))(supervisors)) {
          this.ticket.supervisors.push(user)
        } else {
          this.candidates.supervisors.push(user)
        }

        if (this.$R.find(this.$R.propEq('id', user.id.toString()))(assignees)) {
          this.ticket.assignees.push(user)
        } else {
          this.candidates.assignees.push(user)
        }
      })

      tickets.map((ticket: any) => {
        if (this.$R.find(this.$R.propEq('id', ticket.id.toString()))(relatedTickets)) {
          this.ticket.relatedTickets.push(ticket)
        } else {
          this.candidates.relatedTickets.push(ticket)
        }
      })

      labelsAll.map((label: any) => {
        if (this.$R.find(this.$R.propEq('id', label.id))(labels)) {
          this.ticket.labels.push(label)
        } else {
          this.candidates.labels.push(label)
        }
      })
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  selectUser (user: ReducedUser, type: string, index: number) {
    this.ticket[type].push(user)
    this.candidates[type] = this.$R.remove(index, 1, this.candidates[type])
  }

  unselectUser (user: ReducedUser, type: string, index: number) {
    this.candidates[type].push(user)
    this.ticket[type] = this.$R.remove(index, 1, this.ticket[type])
  }

  unselectUserQuickly (user: ReducedUser, type: string, index: number) {
    this.modal.type = type === 'supervisors'
      ? 'supervisor'
      : 'assignee'
    this.unselectUser(user, type, index)
    this.hideModal()
  }

  selectLabel (label: ReducedLabel, index: number) {
    this.ticket.labels.push(label)
    this.candidates.labels = this.$R.remove(index, 1, this.candidates.labels)
  }

  unselectLabel (label: ReducedLabel, index: number) {
    this.candidates.labels.push(label)
    this.ticket.labels = this.$R.remove(index, 1, this.ticket.labels)
  }

  unselectLabelQuickly (label: ReducedLabel, index: number) {
    this.modal.type = 'label'
    this.unselectLabel(label, index)
    this.hideModal()
  }

  selectTicket (ticket: ReducedTicket, index: number) {
    this.ticket.relatedTickets.push(ticket)
    this.candidates.relatedTickets = this.$R.remove(index, 1, this.candidates.relatedTickets)
  }

  unselectTicket (ticket: ReducedTicket, index: number) {
    this.candidates.relatedTickets.push(ticket)
    this.ticket.relatedTickets = this.$R.remove(index, 1, this.ticket.relatedTickets)
  }

  unselectTicketQuickly (ticket: ReducedTicket, index: number) {
    this.modal.type = 'related'
    this.unselectTicket(ticket, index)
    this.hideModal()
  }

  selectPriority (value: string) {
    this.ticket.priority = value
    this.hideModal()
  }

  routeTo (routeName: string) {
    if (routeName === this.$route.name) {
      return
    }
    this.$router.push({
      name: routeName
    })
  }

  reset () {
    this.ticket = {
      expectedTime: '',
      priority: '',
      labels: [],
      assignees: [],
      supervisors: [],
      relatedTickets: []
    }

    this.candidates = {
      labels: [],
      assignees: [],
      supervisors: [],
      relatedTickets: []
    }
  }
}
